import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css';
import errorCircle from '../assets/error_circle.png';

const SelectInput = ({ name, value, validationMessage, disabled, onBlur, onChange, options }) => {
    return (
        <div className={'_kanis_input_group'}>
            <select
                    className='_kanis_select'
                    name={name}
                    value={value}
                    onBlur={() => onBlur()}
                    onChange={onChange}
                    disabled={disabled}
                >
                    {options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            { !!validationMessage && (
                <div className='_kanis_validation_message'>
                    <img src={errorCircle} alt='error' />
                    <div>{validationMessage}</div>
                </div>
            )}
        </div>
    );
};

export default SelectInput;

SelectInput.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    validationMessage: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
    })),
};
